import { v4 as uuidv4 } from 'uuid';
import { QuoteDTO, QuoteSectionDTO } from '@setvi/shared/services/react-query';
import { useQuoteMutation } from './create-quote-mutation';

interface AddSectionVariables {
  name: string;
  description?: string;
}

/**
 * Add section optimistically to quote
 */
const addSectionOptimistically = (
  quote: QuoteDTO | undefined,
  { name, description }: AddSectionVariables
): QuoteDTO | undefined => {
  if (!quote) return quote;

  const newSection: QuoteSectionDTO = {
    id: uuidv4(),
    type: 'section',
    name,
    note: description || null,
    children: []
  };

  return {
    ...quote,
    items: [...quote.items, newSection]
  };
};

/**
 * Add section to quote with optimistic updates
 * Section appears immediately in UI before API confirmation
 */
export const useAddSection = (quoteId: string) =>
  useQuoteMutation<AddSectionVariables>({
    quoteId,
    optimisticUpdate: addSectionOptimistically
  });
